import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../state/AuthContext.jsx';
import { useNotice } from '../../state/NoticeContext.jsx';
import { authApi } from '../../api/endpoints.js';
import { Button, Card, Text } from '../../ui.jsx';

export default function VerifyEmail() {
  const { verifyEmail } = useAuth();
  const notice = useNotice();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ email: location.state?.email || '', code: '' });
  const [busy, setBusy] = useState(false);
  const [resending, setResending] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    try {
      const data = await verifyEmail({ email: form.email.trim(), code: form.code.trim() });
      notice.success(data.message || 'Email verified.');
      navigate('/profile', { replace: true });
    } catch (error) {
      notice.fromError(error);
    } finally {
      setBusy(false);
    }
  };

  const resend = async () => {
    setResending(true);
    try {
      const data = await authApi.resendVerification(form.email.trim());
      notice.success(data.message || 'Verification code sent.');
    } catch (error) {
      notice.fromError(error);
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="authw">
      <Card>
        <h1 style={{ fontSize: 24, marginBottom: 4 }}>Verify your email</h1>
        <p className="mu" style={{ marginBottom: 16 }}>
          We sent a six-digit code to your email address. Enter it to activate your account.
        </p>
        <form onSubmit={submit}>
          <Text
            label="Email"
            type="email"
            required
            autoComplete="email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
          />
          <div style={{ height: 12 }} />
          <Text
            label="Verification code"
            required
            inputMode="numeric"
            autoComplete="one-time-code"
            maxLength={8}
            value={form.code}
            onChange={(e) => setForm({ ...form, code: e.target.value })}
          />
          <div style={{ height: 16 }} />
          <Button type="submit" busy={busy} style={{ width: '100%' }}>Verify email</Button>
        </form>
        <p className="mu" style={{ marginTop: 16, textAlign: 'center' }}>
          Did not get it?{' '}
          <button type="button" className="lk" onClick={resend} disabled={resending || !form.email}>
            {resending ? 'Sending...' : 'Send again'}
          </button>
        </p>
        <p className="mu" style={{ textAlign: 'center' }}>
          <Link to="/signin">Back to log in</Link>
        </p>
      </Card>
    </div>
  );
}
